import * as React from 'react'

import ScoreView from './ScoreView'
import PlayerInfoRow from '../Elements/PlayerInfoRowElement'

import './MatchTeamViewStyles.scss';
import { RanksByPlayerId } from '../../reducers/statsRanking';

export interface IMatchTeamViewProps {
    homeOrAway: string
    periodScores: any
    ranks: any
    ranksByPlayerIds: RanksByPlayerId
    playerUid: any
    playerNames: any
    servingPlayer: any
    gamePoints: any
    flagUrl: string
    period: string
    playerAbbreviationNames: any
}

const MatchTeamView = (props:IMatchTeamViewProps) => {
    if( !props.ranksByPlayerIds || !props.playerNames || !props.playerAbbreviationNames  ) {
        return null;
    }
    return (
        <div className={`livescore${capitalizeFirstLetter(props.homeOrAway)}`}>
            <div className="rightFloated">
                <div className={`livescoreServing ${isServing( props.homeOrAway, props.servingPlayer )}`}></div>
                <ScoreView homeOrAway={ props.homeOrAway }
                           periodScores={ props.periodScores }
                           gamePoints={ props.gamePoints }
                           period={ props.period }/>
            </div>
            <div className="leftFloated">
                <PlayerInfoRow  flagUrl = { props.flagUrl }
                                rank = { props.ranksByPlayerIds[props.playerUid] }
                                playerName = { props.playerNames[props.homeOrAway] } 
                                playerAbbreviationName = {props.playerAbbreviationNames[props.homeOrAway]} />
            </div>
        </div>
    )
}

const capitalizeFirstLetter = (str:string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

const isServing = (server:string, value:string) => {
    return server == value ? 'serving' : '';
}

export default MatchTeamView
